import { useStaticQuery, graphql, Link } from 'gatsby'

/** @jsx jsx */
import { jsx } from 'theme-ui'


const Footer = () => {
    const data = useStaticQuery(pageQuery)
    const siteName = data.site.siteMetadata.siteTitle
    const localGraphSites = data.site.siteMetadata.localGraphSites

    var today = new Date()

    return (
        <div
            sx={{
                color: 'text',
                fontSize: 1,
                pt: 5, pb: 3,
                a: {
                    textDecoration: 'none',
                }
            }}
        >
            <div>
                Copyright Lyketil SARL - LocalGraph - {siteName} © {today.getFullYear()} Tous droits réservés.
                <br/>
                <Link to='/politique-de-confidentialite' sx={{color: 'text'}}>Politique de confidentialité</Link>
                {` | `}
                <Link to='/a-propos' sx={{color: 'text'}}>A propos</Link> 
                {` | `}
                <Link to='/a-propos#contact' sx={{color: 'text'}}>Contact</Link> 
                {` | `}
                <Link to='/conditions-dutilisation' sx={{color: 'text'}}>Conditions d'utilisation</Link> 
            </div>

            <div sx={{mt: 4, fontSize: 0, maxWidth: '650px', color: 'grey'}}>
                La reproduction, même partielle, de tout texte, image ou photo présents sur ce site est interdite sans accord préalable de l’éditeur. Les logos, marques et marques déposées sont la propriété de leurs détenteurs.
                <br /><span sx={{color: 'grey', fontSize: 0}}>Propulsé par <a href="https://www.lyketil.com" target="blank" sx={{color: 'grey'}}>Lyketil Digital Lab Lausanne</a> <span role="img" aria-label="drapeau suisse icon">🇨🇭</span></span>
            </div>

            <div sx={{
                mt: 4, mb: 3, pt: 4,
                borderTop: theme => `2px solid ${theme.colors.background}`,
                a: {
                    color: 'grey', fontSize: 0,
                }
            }}>
                {localGraphSites.map( site => (
                    <a  
                        key={site.name}
                        href={`https://www.${site.url}`} 
                        title={site.name}
                        target='blank'
                        sx={{ 
                            display: 'inline-block',
                            mr: 1, mb: 1,
                            px: 3, py: 2,
                            bg: "background",
                            borderRadius: 0,
                        }}
                    >
                        {site.name}
                    </a>
                ))}
            </div>
        </div>
    )
}

export default Footer

const pageQuery = graphql`
  query footerQuery {
    site {
      siteMetadata {
        siteTitle
        siteDesc
        siteTagline
        localGraphSites {
            name
            url
        }
      }
    }
  }
`